import * as React from 'react';
import { Provider } from 'react-redux';
import { getStore } from './store';

// Сейчас у нас компоненты создаются изолированно, поэтому необходимо каждый
// раз оборачивать в Provider, в будущем эта проблема отпадет при отказе от ангуляра
export function withProvider<T extends object>(WrappedComponent: React.ComponentType<T>) {
  return (props: T) => {
    const store = getStore();

    return (
      <Provider store={store}>
        <WrappedComponent {...(props as T)} />
      </Provider>
    );
  };
}
